import { useCallback, useEffect, useRef } from 'react';

/** Own one request at a time; stale promises cannot update a newer view. */
export function useRequestGate() {
  const active = useRef(null);
  const cancel = useCallback(() => {
    const previous = active.current;
    active.current = null;
    previous?.abort();
  }, []);
  const begin = useCallback(() => {
    cancel();
    const controller = new AbortController();
    active.current = controller;
    return controller;
  }, [cancel]);
  const isCurrent = useCallback((controller) => active.current === controller && !controller.signal.aborted, []);
  const pending = useCallback(() => active.current !== null, []);
  const complete = useCallback((controller) => {
    if (active.current !== controller) return false;
    active.current = null;
    return true;
  }, []);
  useEffect(() => cancel, [cancel]);
  return { begin, cancel, isCurrent, pending, complete };
}